import CustomModals from "Component/Admin/Modal";
import AxiosUtil from "Component/Modules/API/AxiosUtil";
import PasswordModal from "Component/PasswordModal";
import { passwordAuthState } from "Component/Modules/Store/PasswordAuth.recoil";
import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import { RecoilRoot, useRecoilState } from "recoil";
import "../src/Assets/font/font.scss";
import "../src/Assets/style/_grid.scss";
import "../src/Assets/style/_reset.scss";
import "./App.css";
import RouterWrapper from "./Pages/Routers/RouterWrapper";

const AppContent: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useRecoilState(passwordAuthState);

  const handlePasswordCorrect = () => {
    setIsAuthenticated(true);
  };

  return (
    <>
      <BrowserRouter>
        <Route path={"/"} component={RouterWrapper} />
      </BrowserRouter>
      <CustomModals />
      <PasswordModal 
        isOpen={!isAuthenticated} 
        onPasswordCorrect={handlePasswordCorrect} 
      />
    </>
  );
};

function App() {
  return (
    <RecoilRoot>
      <AxiosUtil>
        <AppContent />
      </AxiosUtil>
    </RecoilRoot>
  );
}

export default App;
